import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface ILayoutStateSlice {
  topRightIcon?: ITopRightIcon;
  layoutState: IReduxLoadingState;
  showHeader: boolean;
  pageTabs: Dictionary<string | string[]>;
  menuOpen: boolean;
  searchPatientModalOpen: "global" | "watchlist" | "bedExit" | null;
}

const name = "Layout";
export const initialState: ILayoutStateSlice = {
  topRightIcon: undefined,
  layoutState: "pending",
  showHeader: true,
  pageTabs: {},
  menuOpen: false,
  searchPatientModalOpen: null,
};

export const layoutSlice = createSlice({
  name,
  initialState,
  reducers: {
    setTopRightIcon(state, action: PayloadAction<ITopRightIcon | undefined>) {
      state.topRightIcon = action.payload;
    },
    setPageTabs(
      state,
      action: PayloadAction<{
        key: string;
        value: string | string[];
      }>
    ) {
      state.pageTabs = {
        ...state.pageTabs,
        [action.payload.key]: action.payload.value,
      };
    },
    setLayoutState: (
      state,
      action: PayloadAction<Partial<ILayoutStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.menuOpen = action.payload;
    },
    setSearchPatientModalOpen: (
      state,
      action: PayloadAction<"global" | "watchlist" | "bedExit" | null>
    ) => {
      state.searchPatientModalOpen = action.payload;
    },
  },
});

export const {
  setTopRightIcon,
  setLayoutState,
  setPageTabs,
  setMenuOpen,
  setSearchPatientModalOpen,
} = layoutSlice.actions;

export default layoutSlice.reducer;
